import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { Relations } from './relation.entity';
import { RelationsAdapter } from './dto/relation.adapter';
import { RelationDTO } from './dto/relation.dto';
import { RelationResponseModel,AllRelationsResponseModel } from '@gtpl/shared-models/masters';
import { RelationRequest } from './dto/relation.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
@Injectable()
export class RelationsService {
    constructor(
        private logService:LogsService,
        @InjectRepository(Relations)
        private relationsRepository: Repository<Relations>,
        private relationsAdapter: RelationsAdapter,
      ) {}
    /**
     * create/update relation
     * @param relationDTO 
     * @param isUpdate 
     * @param request 
     */
    async createRelation(relationDTO: RelationDTO, isUpdate: boolean,request:Request): Promise<RelationResponseModel> {
        try {
            console.log(isUpdate);
            // to check whether Relation exists with the passed  Relation  or not. if isUpdate is false, a check will be done whether a record with the passed Relation is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Relation  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const relationEntity = await this.getRelationDetailsWithoutRelations(relationDTO.relation);
                if (relationEntity) {
                    throw new ErrorResponse(11104, 'Relation already exists');         
                } 
            // var notificationStatus='Created';
            }else{
                const relationEntity = await this.getRelationDetailsWithoutRelations(relationDTO.relation);
                if(relationEntity){
                    if(relationEntity.relationId!=relationDTO.relationId) {
                        throw new ErrorResponse(11104, 'Relation already exists');      
                    }
                }
            }

            // else{
            // var notificationStatus='Updated';
            // }
            const convertedRelationEntity: Relations = this.relationsAdapter.convertDtoToEntity(relationDTO,isUpdate);
            const savedRelationEntity: Relations = await this.relationsRepository.save(
            convertedRelationEntity
            );
            const savedRelationDto: RelationDTO = this.relationsAdapter.convertEntityToDto(savedRelationEntity);
            if (savedRelationDto) {
            // generating resposnse
            const response = new RelationResponseModel(true,isUpdate ? 11101 : 11100,isUpdate? 'Relation Updated Successfully': 'Relation Created Successfully',savedRelationDto);
            const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'Relations', savedRelationDto.relationId, true, '',savedRelationDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            } else {
            throw new ErrorResponse(11106,'Relation saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            throw error;
        }
    }
    /**
     * get relation details
     * @param relationName 
     */
    // @LogActions({isAsync: true})
    async getRelationDetailsWithoutRelations(relation: string): Promise<Relations> {
        // tslint:disable-next-line: typedef
        const relationResponse = await this.relationsRepository.findOne({
        where: {relation: Raw(alias => `relation = '${relation}'`)},
        });
        if (relationResponse) {
        return relationResponse;
        } else {
        return null;
        }
    }

     /**
     * gets all relations details  
     * @returns all relations details .
     */
    async getAllRelations(): Promise<AllRelationsResponseModel> {
        // const page: number = 1;
        try {
          const relationsDTO: RelationDTO[] = [];
          //retrieves all companies
          const relationEntities: Relations[] = await this.relationsRepository.find({order :{'createdAt':'DESC'}});
          //console.log(relationEntities);
          if (relationEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            relationEntities.forEach(relationEntity => {
              const convertedstatesDto: RelationDTO = this.relationsAdapter.convertEntityToDto(
                relationEntity
              );
              relationsDTO.push(convertedstatesDto);
            });
            const response = new AllRelationsResponseModel(true,11108,"Relations retrieved successfully",relationsDTO);
           
            const newLogDto = new LogsDto(1,'view', 'Relations', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        } catch (err) {
          throw err;
        }
      }

    /**
     * It deactivates Relation 
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateorDeactivateRelation(relationReq: RelationRequest): Promise<RelationResponseModel> {
      try {
          const relationExists = await this.getRelationById(relationReq.relationId);
          if (relationExists) {
              if (relationReq.versionFlag !== relationExists.versionFlag) {
                  throw new ErrorResponse(10113, 'Someone updated the current Relation information.Refresh and try again');
              } else {
                  
                      const relationStatus =  await this.relationsRepository.update(
                          { relationId: relationReq.relationId },
                          { isActive: relationReq.isActive,updatedUser: relationReq.updatedUser });
                     
                      if (relationExists.isActive) {
                          if (relationStatus.affected) {
                              const relationResponse: RelationResponseModel = new RelationResponseModel(true, 10115, 'Relation is de-activated successfully');
                              return relationResponse;
                          } else {
                              throw new ErrorResponse(10111, 'Relation is already deactivated');
                          }
                      } else {
                          if (relationStatus.affected) {
                              const relationResponse: RelationResponseModel = new RelationResponseModel(true, 10114, 'Relation is activated successfully');
                              return relationResponse;
                          } else {
                              throw new ErrorResponse(10112, 'Relation is already activated');
                          }
                      }
                  // }
              }
          } else {
              throw new ErrorResponse(99998, 'No Records Found');
          }
      } catch (err) {
          throw err;
      }
  }
  /**
   * get Relation while passing id
   * @param relationId 
   */
  async getRelationById(relationId: number): Promise<Relations> {
        const Response = await this.relationsRepository.findOne({
        where: {relationId: relationId},
        });
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }
      
}
